import * as React from 'react';

import { Box, Spinner, Stack } from '@origin-digital/ods-core';

export const Loading: React.SFC = ({ children }) => (
  <Stack space="large" alignX="center">
    <Box marginTop="xxxlarge">
      <Spinner size="large" data-id="spinner" />
    </Box>
    {children}
  </Stack>
);
